import { Flex, Form, DatePicker, TimePicker, Checkbox } from "antd"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import { Text } from "ui/Typography"
import { endTimeValidate, startTimeValidate } from "pagesV2/pro/Calendar/utils"
import PropTypes from "prop-types"
import dayjs from "dayjs"

const SingleDay = ({ form }) => {
  const { t } = useTranslation()
  const checked = Form.useWatch("singleDayFullDay", form)

  return (
    <Flex vertical gap={spacings.M}>
      <Text fw={500}>{t("calendar.schedule_time_off.select_a_day_off")}</Text>
      <Flex gap={spacings.XXS} vertical>
        <Text fw={500}>{t("calendar.schedule_time_off.date")}</Text>
        <Form.Item shouldUpdate={(prev, curr) => prev.singleDayFullDay !== curr.singleDayFullDay} noStyle>
          {() => {
            const isFullDay = form.getFieldValue("singleDayFullDay")
            return (
              <Flex justify="space-between" gap={spacings.M}>
                <Form.Item name="singleDayDate" className="w-full" rules={[{ required: true, message: "Date is required" }]}>
                  <DatePicker
                    className="w-full"
                    placeholder="MM/DD/YYYY"
                    format="MM/DD/YYYY"
                    disabledDate={(current) => current?.isBefore(dayjs()?.startOf("day"))}
                  />
                </Form.Item>
                <Form.Item
                  name="singleDayStartTime"
                  className="w-full"
                  rules={
                    isFullDay
                      ? []
                      : [
                          { required: true, message: "Start time is required" },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              return startTimeValidate(t, getFieldValue("singleDayEndTime"), value)
                            }
                          })
                        ]
                  }
                >
                  <TimePicker
                    use12Hours
                    format="hh:mm a"
                    needConfirm={false}
                    className="w-full"
                    placeholder="Start Time"
                    disabled={isFullDay}
                  />
                </Form.Item>
                <Form.Item
                  name="singleDayEndTime"
                  className="w-full"
                  rules={
                    isFullDay
                      ? []
                      : [
                          { required: true, message: "End time is required" },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              return endTimeValidate(t, getFieldValue("singleDayStartTime"), value)
                            }
                          })
                        ]
                  }
                >
                  <TimePicker
                    use12Hours
                    format="hh:mm a"
                    needConfirm={false}
                    className="w-full"
                    placeholder="End Time"
                    disabled={isFullDay}
                  />
                </Form.Item>
                <Form.Item className="w-full" name="singleDayFullDay" valuePropName="checked">
                  <Flex align="center" gap={spacings.XS}>
                    <Checkbox
                      checked={checked}
                      onChange={(e) => {
                        if (e.target?.checked) {
                          form.setFieldsValue({ singleDayStartTime: null, singleDayEndTime: null })
                        }
                      }}
                    />
                    <Text>{t("calendar.schedule_time_off.full_day")}</Text>
                  </Flex>
                </Form.Item>
              </Flex>
            )
          }}
        </Form.Item>
      </Flex>
    </Flex>
  )
}

SingleDay.propTypes = {
  form: PropTypes.object
}

export default SingleDay
